/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
    FacilityServiceAreaStatusToJSONTyped,
} from './FacilityServiceAreaStatus';

/**
 * 
 * @export
 * @interface UpdateFacilityServiceAreaRequest
 */
export interface UpdateFacilityServiceAreaRequest {
    /**
     * A 5-digit US ZIP code (e.g. "10001").
     */
    zip: string;
    /**
     * 
     */
    status: FacilityServiceAreaStatus;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    notes?: string;
}



/**
 * Check if a given object implements the UpdateFacilityServiceAreaRequest interface.
 */
export function instanceOfUpdateFacilityServiceAreaRequest(value: object): value is UpdateFacilityServiceAreaRequest {
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateFacilityServiceAreaRequestFromJSON(json: any): UpdateFacilityServiceAreaRequest {
    return UpdateFacilityServiceAreaRequestFromJSONTyped(json, false);
}

export function UpdateFacilityServiceAreaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityServiceAreaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'zip': json['zip'],
        'status': FacilityServiceAreaStatusFromJSON(json['status']),
        'city': json['city'] == null ? undefined : json['city'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateFacilityServiceAreaRequestToJSON(json: any): UpdateFacilityServiceAreaRequest {
    return UpdateFacilityServiceAreaRequestToJSONTyped(json, false);
}

export function UpdateFacilityServiceAreaRequestToJSONTyped(value?: UpdateFacilityServiceAreaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'zip': value['zip'],
        'status': FacilityServiceAreaStatusToJSON(value['status']),
        'city': value['city'],
        'state_id': value['state_id'],
        'notes': value['notes'],
    };
}

